export default __webpack_public_path__ + "static/media/icon_calendar.012cc8be.png";